import type { FunctionComponent } from 'react';

import { FormattedMessage } from '../../../shared/components/formatted-message/formatted-message';
import { Icon } from '../../../shared/components/icon/icon';
import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';

import styles from './game-navigation-bar.module.scss';

const style = createStyleHelper(styles, 'game-navigation-bar');

export interface IGameNavigationBarProps {
    className?: string;
    updateSlotCount: (count: number) => void;
    toggleSearch: () => void;
    isSearchOpen: boolean;
}

export const GameNavigationBar: FunctionComponent<IGameNavigationBarProps> = ({
    className,
    toggleSearch,
    updateSlotCount,
    isSearchOpen,
}) => {
    return (
        <nav className={createClassName([style(), className])}>
            <button
                onClick={() => toggleSearch()}
                className={style('button', { search: isSearchOpen })}
            >
                <Icon className={style('icon', { search: isSearchOpen })} name={'search'} />
                <FormattedMessage id="gameplay.navigation-buttom.search" defaultMessage="Search" />
            </button>
            <button onClick={() => updateSlotCount(1)} className={style('button')}>
                <Icon className={style('icon')} name={'square'} />
                <FormattedMessage id="gameplay.navigation-buttom.x-one" defaultMessage="X1" />
            </button>
            <button onClick={() => updateSlotCount(2)} className={style('button')}>
                <Icon className={style('icon')} name={'table'} />
                <FormattedMessage id="gameplay.navigation-buttom.x-two" defaultMessage="X2" />
            </button>
        </nav>
    );
};
